import db from "../db/database";
import { fetchFromBusinessCentral } from "../utils/businessCentralUtils";
import { mapApiOptionsResponse } from "../utils/syncUtils";
import { isOnline } from "./syncService";

/**
 * Mapa de endpoints -> tabla Dexie + endpoint
 */
const endpointConfig = {
    Departamentos: {
        table: "departamentos",
        path: "DepartamentosFE"
    },
    Distritos: {
        table: "distritos",
        path: "DistritosFE"
    },
    Ciudades: {
        table: "ciudades",
        path: "CiudadesFE"
    },
    Vendedores: {
        table: "vendedores",
        path: "Salesperson"
    },
    GrupoPrecios:{
        table: "grupoPrecios",
        path: "CustomerPriceGroup"
    }
}

/**
 * Fetch genérico de opciones para el componente select (antd) y guardado en la tabla correcta,
 */
export const fetchSelectOptions = async (endpoint) => {
    if (!isOnline()) {
        return false;
    }

    try {

        const cfg = endpointConfig[endpoint];
        if (!cfg) {
            console.error(`No hay configuración para endpoint '${endpoint}'.`);
            return false;
        }
        const { table, path } = cfg;

        if (!db[table]) {
            console.error(`La tabla Dexie '${table}' no existe.`);
            return false;
        }

        await db[table].clear();

        const options = await fetchFromBusinessCentral(path);
        const selectOptions = mapApiOptionsResponse(options);
        const now = new Date();

        const records = selectOptions.map((opt) => ({
            ...opt,
            lastModified: now,
            lastSynced: now,
        }));

        await db[table].bulkAdd(records);
        return true;
    } catch (error) {
        return false;
    }
};

/**
 * Construye opciones listas para usar en Select de Ant Design
 */
export const buildSelectOptions = async (endpoint) => {
    try {
        const cfg = endpointConfig[endpoint];
        if (!cfg) {
            console.error(`No se encontró la configuración "${endpoint}"`);
            return [];
        }
        const { table } = cfg;

        // Si la tabla no existe en Dexie
        if (!db[table]) {
            console.error(`La tabla "${table}" no existe en la base de datos`);
            return [];
        }


        // Obtener registros actualizados desde Dexie
        const records = await db[table].toArray();

        return records;
    } catch (error) {
        console.error(`Error al construir opciones para ${endpoint}:`, error);
        return [];
    }
};
